(function () {

    "use strict";

    function checkboxController() {
        
    }

    checkboxController.$inject = [];

    angular.module("sphforms.main")
        .component("sphFormsCheckbox", {
            controller: checkboxController,
            bindings: {
                nameLabel: "=",
                model: "=",
                disable: "=",
                required: "=",
                change: "&"
            },
            templateUrl: "modules/main/components/ui/checkbox/checkbox.template.html"
        });

}());
